export default __webpack_public_path__ + "static/media/rarity-btn-common.465335d2.svg";